import React, { useEffect } from 'react'
import { authService } from '@services'
import { Redirect, Route } from 'react-router-dom'
import { UserProvider } from '@context'

function ProtectedRoute ({ component: Component, ...restOfProps }) {
  const redirectPath = window.location.pathname
  const isAuthenticated = authService.isAuthenticated()

  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key !== 'token') {
        return
      }

      if (event.newValue) {
        window.location.replace('/parentsmeeting')
      } else {
        window.location.replace('/login')
      }
    }

    window.addEventListener('storage', handleStorage)

    return () => {
      window.removeEventListener('storage', handleStorage)
    }
  }, [])

  return (
    <Route
      {...restOfProps}
      render={props =>
        isAuthenticated ? (
          <UserProvider>
            <Component {...props} />
          </UserProvider>
        ) : (
          <Redirect to={`/login?redirectTo=${redirectPath}`} />
        )
      }
    />
  )
}

export default ProtectedRoute
